import Emmiter from './emitter';
const singleton = Symbol();
const singletonEnforcer = Symbol();

class Session extends Emmiter {
  constructor(enforcer) {
    super();
    if (enforcer !== singletonEnforcer) {
      throw new Error('Cannot construct singleton');
    }
    this._firstTime = localStorage.getItem('firstTime') || true;


  }
  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new Session(singletonEnforcer);
    }
    return this[singleton];
  }

  get firstView() {
    return this._firstTime;
  }
  
  set firstView(value) {
    localStorage.setItem('firstTime', value);
    this._firstTime = value;
  }


}

export default Session;